/////tsnocheck
import { CompanyInfo } from '@oai-frontend-monorepo/types';
import createClient from '../create-client';

export class CompanyApiClient {
  private client: ReturnType<typeof createClient>;

  constructor(getToken?: () => Promise<string | undefined>) {
    this.client = createClient(``, getToken);
  }

  public async companyInfo(symbol?: string) {
    if (!symbol) {
      throw new Error('Symbol is required');
    }

    const res = await this.client.get<{ [key: string]: CompanyInfo }>(
      `/v2/companies?symbol=${symbol}`
    );

    return res?.[symbol] || null;
  }

  public registerGetToken(
    baseUrl: string,
    getToken?: () => Promise<string | undefined>
  ) {
    this.client = createClient(baseUrl, getToken);

    return this;
  }
}

export default new CompanyApiClient();
